import { ThemeProvider } from '@material-ui/core/styles'
import AppSnackbarProvider from 'components/app-snackbar-provider'
import { Helmet } from 'react-helmet'
import themes, { extendTheme } from 'themes'
import CoachAppBar from 'components/coach-app-bar'
import { withAuthenticatedRoute } from 'lib/auth'

const PaymentRequestShell = ({ children, ...props }) => {
  return (
    <ThemeProvider theme={extendTheme(themes.offeringsRefresh)}>
      <Helmet>
        <title>MyPGA | Club</title>
        <meta name="description" content="MyPGA" />
        <script async src="https://js.stripe.com/v3/"></script>
        <link rel="icon" href="/pga-coach-favicon.ico" />
      </Helmet>
      <AppSnackbarProvider
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <CoachAppBar position="relative" hideContactButton />
        {children}
      </AppSnackbarProvider>
    </ThemeProvider>
  )
}
export default withAuthenticatedRoute(PaymentRequestShell)
